export const dynamicEnvs = [
  {
    environmentName: 'qa1',
    baseUrl: 'https://qa.incentivioqa1.com',
    environmentDescription: 'this is test env qa1',
  },
  {
    environmentName: 'qa2',
    baseUrl: 'https://qa.incentivioqa2.com',
    environmentDescription: 'this is test env qa2',
  },
  {
    environmentName: 'QA',
    baseUrl: 'https://qa.incentivioqa.com',
    environmentDescription: 'this is test env QA',
  },
  {
    environmentName: 'eks-qa-7',
    baseUrl: 'https://qa.incentivio-eks-qa-7.com',
    environmentDescription: 'this is eks env',
  },
  {
    environmentName: 'qa3',
    baseUrl: 'https://qa.incentivioqa.com',
    environmentDescription: 'this is test env QA',
  },
  {
    environmentName: 'qa4',
    baseUrl: 'https://qa.incentivioqa4.com',
    environmentDescription: 'this is test env QA',
  },
  {
    environmentName: 'eks-qa-9',
    baseUrl: 'https://qa.incentivio-eks-qa-9.com',
    environmentDescription: 'qa eks 9 env',
  },
  {
    environmentName: 'eks-qa-8',
    baseUrl: 'https://qa.incentivio-eks-qa-8.com',
    environmentDescription: 'this is eks 8 env',
  },
  {
    environmentName: 'eks-qa-10',
    baseUrl: 'https://qa.incentivio-eks-qa-10.com',
    environmentDescription: 'qa eks 10 env',
  },
];
